import { useState, useEffect } from 'react';
import hero1 from '../../assets/images/hero1.png'
import { useNavigate } from 'react-router-dom';
import hero3 from '../../assets/images/hero3.jpg';
import hero4 from '../../assets/images/hero4.jpg';
const HeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const handleRegisterClick = (subject) => {
    navigate('/', { state: { scrollToContact: true, subject } });
  };
  const images = [hero1, hero3, hero4];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // chuyển ảnh mỗi 3 giây
    return () => clearInterval(interval);
  }, []);
  return (
    <section className="bg-gradient-to-br from-blue-50 to-green-50 py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold">
                <span className="text-primary-600">Nâng Tầm Tri Thức</span>
                <span className="text-gray-900"> Vươn Xa Tương Lai</span>
              </h1>

              <div className="space-y-4 text-justify">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Nơi Chất Lượng Giảng Dạy Tạo Nên Sự Khác Biệt Tại Trung Tâm Văn Hóa Ngoài Giờ Nam Kiến Văn chúng tôi tin rằng chất lượng giảng dạy là yếu tố cốt lõi định hình nên tương lai của người học.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Đội ngũ giáo viên của chúng tôi không chỉ là những người truyền đạt kiến thức, mà còn là những nhà sư phạm đầy tâm huyết, giàu kinh nghiệm và luôn đổi mới.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Với sự am hiểu sâu sắc về chuyên môn, khả năng truyền cảm hứng và phương pháp giảng dạy hiện đại, mỗi giáo viên của chúng tôi cam kết mang đến những buổi học không chỉ bổ ích mà còn thực sự lôi cuốn và tương tác.
                </p>
              </div>

            </div>

            <button className="btn bg-orange-500 text-white hover:bg-orange-400 text-lg px-8 py-4"
              onClick={() => handleRegisterClick()}
            >
              Liên Hệ Chúng Tôi
            </button>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-3xl p-8 relative overflow-hidden">
              <div className="relative z-10">
                <div className="w-full h-80 bg-gray-200 rounded-2xl flex items-center justify-center overflow-hidden">
                  <span className="text-gray-500 text-lg w-full h-full block">
                    <img
                      src={images[currentImageIndex]}
                      alt={`Slide ${currentImageIndex + 1}`}
                      className="w-full h-full object-cover rounded-2xl transition-all duration-700"
                    />
                  </span>
                </div>
                <div className="absolute bottom-4 right-4 bg-yellow-400 text-black px-4 py-2 rounded-full font-bold">
                  Môi Trường Thân Thiện
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute top-4 right-4 w-16 h-16 bg-white/20 rounded-full"></div>
              <div className="absolute bottom-20 left-4 w-8 h-8 bg-white/30 rounded-full"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
